import { render, staticRenderFns } from "./SoftwareComponentFullList.vue?vue&type=template&id=433b944a&"
import script from "./SoftwareComponentFullList.vue?vue&type=script&lang=js&"
export * from "./SoftwareComponentFullList.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareComponentFullList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports